import React from 'react'
import Slider from 'react-slick'
import Image from 'next/image'
import { carouselSettings } from '@/utils/carourselConfig'
import { getScreenWidth } from '@/utils/clientEnv'
import Markdown from '@/components/common/Markdown'
import Link from 'next/link'

const Carousel = ({ data = null, handleClick }) => {
  if (getScreenWidth() <= 480) carouselSettings.speed = 50

  const defaultImageUrl =
    'https://images.ctfassets.net/p6iqoqavudao/3lLPw0ct3NWRdllJaozgZr/238aa02d0b3a99038d1969146d7916f1/placeholder.png'
  return (
    <Slider {...carouselSettings}>
      {data?.map((item, i) => (
        <div className="flex-1 pr-2 pl-2 xs:pl-0" key={i} onClick={() => handleClick(item.slug)}>
          <Link href={`/speaker/${item?.slug}`} key={item?.slug} passHref legacyBehavior>
            <a className="mb-2 cursor-pointer group">
              {item?.assets?.fields?.file?.url !== undefined ? (
                <Image
                  className="w-[290px] h-[395px] object-cover"
                  priority
                  src={`https:${item?.assets?.fields?.file?.url}?w=290&h=395&q=100&fit=thumb&f=top`}
                  alt=""
                  width={290}
                  height={395}
                  quality={100}
                />
              ) : (
                <Image
                  src={`${defaultImageUrl}?w=290&h=395&q=100&fit=thumb&f=top`}
                  alt=""
                  width={290}
                  height={395}
                  quality={100}
                />
              )}

              <div
                className="pt-4 text-base font-medium cursor-pointer group-hover:link-underline"
                data-cy="speaker"
              >
                <Markdown data={item.name} />
              </div>
              <div className="text-xs font-normal text-left cursor-pointer xs:text-sm text-custom-gray-90 sm:leading-9 group-hover:text-white">
                <Markdown data={item.subline} />
              </div>
            </a>
          </Link>
        </div>
      ))}
    </Slider>
  )
}

export default Carousel
